import Button from "@mui/material/Button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { keys } from "../../../api/queryKeys.ts";
import { api } from "../../../api/client.ts";

interface ClassifyButtonProps {
  companyId: string;
  hasExisting: boolean;
}

export default function ClassifyButton({ companyId, hasExisting }: ClassifyButtonProps) {
  const queryClient = useQueryClient();

  const classify = useMutation({
    mutationFn: () => api.classifyCompany(companyId),
    onSuccess: () => {
      toast.success("Company classified");
      queryClient.invalidateQueries({ queryKey: keys.masterCompany.detail(companyId) });
    },
  });

  return (
    <Button
      size="small"
      onClick={() => classify.mutate()}
      loading={classify.isPending}
      loadingPosition="start"
    >
      {hasExisting ? "Re-classify" : "Classify company"}
    </Button>
  );
}
